import React, { useState, forwardRef, useEffect } from "react";
import FaqAnswer from "./FaqAnswer";

function FaqQuestion({ question, answer, selectedQuestion }, ref) {
  const [questionToggle, setQuestionToggle] = useState(false);

  // Add scroll event to myRef.current
  useEffect(() => {
    selectedQuestion && setQuestionToggle(true);
    if (ref !== null) {
      ref.current.scrollIntoView({ block: "center", behavior: "smooth" });
    }
  }, [selectedQuestion, ref]);

  return (
    <section className="CallToAction hds-container bg-white hds-text-color question">
      <div className="hds-section-sm flex flex-wrap md:justify-center border-b">
        <div className="w-full">
          <p className="text-xl font-bold mb-4 flex flex-nowrap justify-between">
            <span className="self-center pr-12" ref={ref}>
              {question}
            </span>{" "}
            <span
              className="text-secondary text-2xl select-none cursor-pointer absolute right-4 top-0 flex items-center justify-end h-full pb-4 w-12"
              onClick={() => setQuestionToggle(!questionToggle)}
            >
              {questionToggle ? "-" : "+"}
            </span>
          </p>
          {questionToggle && <FaqAnswer answer={answer} />}
        </div>
      </div>
    </section>
  );
}

const forwardFaqQuestion = forwardRef(FaqQuestion);

export default forwardFaqQuestion;
